import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const submitEnquiry = async (formData) => {
  await addDoc(collection(db, 'inquiries'), {
    ...formData,
    source: 'enquiry',
    read: false,
    createdAt: serverTimestamp(),
  });
};

export const submitContactForm = async (formData) => {
  await addDoc(collection(db, 'inquiries'), {
    ...formData,
    source: 'contact',
    read: false,
    createdAt: serverTimestamp(),
  });
};
